var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 60,
    stroke: "#1C1356",
    strokeWidth: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.4,
    y1: 127.4,
    x2: 167.4,
    y2: 167.4,
    stroke: "#1C1356",
    strokeWidth: 16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 60,
    r: 20,
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 50,
    x2: 150,
    y2: 70,
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 50,
    x2: 130,
    y2: 70,
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.9fab80b0.svg";
export { ForwardRef as ReactComponent };